import './App.css';
import Countries from './components/Countries/Countries';
// import Friends from './components/Friends/Friends';
// import Header from './components/Header/Header';


function App() {
  return (
    <div className="App">
      <Countries></Countries>
    </div>
  );
}


export default App;
